import { motion } from "framer-motion";
import { Eyebrow, MaskedLines } from "./Motion";

export const PageHero = ({ eyebrow, lines, intro, image, testId }) => (
  <section data-testid={testId} className="relative overflow-hidden pb-16 pt-36 sm:pb-24 sm:pt-44">
    {image && (
      <motion.div className="absolute inset-0" initial={{ scale: 1.15, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}>
        <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#07040D]/70 via-[#07040D]/80 to-[#07040D]" />
      </motion.div>
    )}
    <div className="stars absolute inset-0 opacity-60" />
    <div className="absolute left-1/2 top-0 h-[480px] w-[900px] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(212,175,55,0.12),transparent)]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="font-display mt-6 text-5xl leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-8xl">
        <MaskedLines lines={lines} />
      </h1>
      {intro && (
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.9 }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
